import styled from '@emotion/styled';

import { COLOR_TEXT_PRIMARY } from './utils/variables';

export const BreadcrumbCurrent = styled.span`
  color: ${COLOR_TEXT_PRIMARY};
  font-weight: 500;
`;
